declare const __CONFIG__: {
  billingApiUrl: string;
  castingMediaApiUrl: string;
  emailSettingsApiUrl: string;
  linkboardApiUrl: string;
  liteAgentApiUrl: string;
  locationsApiUrl: string;
  oidc: {
    authority: string;
    clientId: string;
  };
  profileApiUrl: string;
  suggestionsApiUrl: string;
  titaniumApiUrl: string;
  userAccountApiUrl: string;
  whoAmIUrl: string;
};

export default {
  ...__CONFIG__,
};
